import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ModalStateService } from '@src/shared/services/authV3/modal-state.service';

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss']
})
export class RadioGroupComponent implements OnChanges {

  @Input() options: { id: number, titulo: string, descricao: string }[] = [];
  @Output() selectionChange = new EventEmitter<{ id: number; index: string }>();
  selectedOption: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options && this.options.length > 0) {
      const defaultId =  sessionStorage.getItem('defalutCompanyId');
      const defaultCompany = this.options.find(opt => opt.id === Number(defaultId));
      if (defaultCompany) {
        this.selectedOption = defaultCompany.id;
        this.selectionChange.emit({ id: defaultCompany.id, index: defaultCompany.descricao });
      } else {
        const first = this.options[0];
        this.selectedOption = first.id;
        this.selectionChange.emit({ id: first.id, index: first.descricao });
      }
    }
  }

  selectOption(id: number, index: string) {
    this.selectedOption = id;
    this.selectionChange.emit({ id, index });
  }
}
